import { render, staticRenderFns } from "./route-btn.vue?vue&type=template&id=2f47c8c7&scoped=true&"
import script from "./route-btn.vue?vue&type=script&lang=ts&"
export * from "./route-btn.vue?vue&type=script&lang=ts&"
import style0 from "./route-btn.vue?vue&type=style&index=0&id=2f47c8c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47c8c7",
  null
  
)

export default component.exports